import React from "react";
import { FiCheck, FiX } from "react-icons/fi";
import "./Switch.css";

interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
}

const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  label = "Active",
}) => {
  const CheckIcon = FiCheck as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  const FixIcon = FiX as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

  return (
    <div className="custom-switch-wrapper">
      <div
        className={`custom-switch ${checked ? "checked" : ""}`}
        onClick={onChange}
      >
        <div className="custom-switch-thumb">
          {checked ? <CheckIcon fontSize={12} /> : <FixIcon fontSize={12} />}
        </div>
      </div>
      <span className="custom-switch-label">{label}</span>
    </div>
  );
};

export default Switch;
